import { FormContext, PanelContext } from '@nrdy-marketing-engine/form-context';
import { useContext, useEffect, useRef } from 'react';
import { TrackEventNameType } from '../@types/schema';
import { track } from './track';

const argsByAction = (event) => {
  const target = event.target;
  const currentTarget = event.currentTarget;

  return {
    click: {
      target: currentTarget.tagName,
      value: currentTarget.textContent,
      text: currentTarget.textContent,
    },
    blur: {
      target: target.tagName,
      value: target.value,
      text: target.value,
    },
    load: {
      target: 'page',
    },
  };
};

const useDomTracking = (eventName: TrackEventNameType) => {
  const domTrackable = useRef<any>();
  const panelArgs = useContext(PanelContext);
  const formArgs = useContext(FormContext);

  useEffect(() => {
    const element = domTrackable.current;

    const trackEvent = (event, eventName) => {
      track(eventName, {
        ...argsByAction(event)[eventName],
        ...panelArgs,
        ...formArgs,
      });
    };

    if (element) {
      element.addEventListener(eventName, (event) => trackEvent(event, eventName), {
        passive: true,
      });
    }

    return () => element?.removeEventListener(eventName, (event) => trackEvent(event, eventName));
  }, [eventName, formArgs, panelArgs]);

  return domTrackable;
};

export default useDomTracking;
